/*!
 * Copyright © 2018-2022. Verizon Connect Ireland Limited. All rights reserved.
 */
import {
  IVehicleDriverPanelPreferences,
  EVehicleDriverPanelTabs,
  IMapOptionsPanelPreferences,
  IVehicleListPanelPreferences,
  EVehicleSelectionMode,
  EGarminStopStatusGroup,
  EVehiclesSortType,
  EMapTypeId,
  EDriverStatusSortType
} from '../../models';

export interface ILayoutPreferencesState {
  mapOptions: IMapOptionsPanelPreferences;
  vehiclesSortType: EVehiclesSortType;
  vehicleDriverPanel: IVehicleDriverPanelPreferences;
  vehicleListPanel: IVehicleListPanelPreferences;
}

export const initialLayoutPreferencesState: ILayoutPreferencesState = null;

export const defaultLayoutPreferences: ILayoutPreferencesState = {
  mapOptions: {
    isSuggestedGeofencesEnabled: false,
    isTrafficEnabled: false,
    isGeofencesEnabled: false,
    isGarminStopsEnabled: false,
    isWorkOrdersEnabled: false,
    isClusteringEnabled: false,
    isShowLabelsEnabled: false,
    isShowTachoInformationEnabled: false,
    isShowVehicleBalloonLinksEnabled: true,
    advancedOptions: {
      placeCategoryIds: null,
      garminStopStatusesIdsSelected: [
        EGarminStopStatusGroup.QUEUED,
        EGarminStopStatusGroup.RECEIVED,
        EGarminStopStatusGroup.READ,
        EGarminStopStatusGroup.EN_ROUTE,
        EGarminStopStatusGroup.COMPLETED
      ]
    },
    mapType: EMapTypeId.ROADMAP,
    workingTimeDirective: {
      filter: null,
      sortType: EDriverStatusSortType.StartTime,
      filterBreakDue: false
    },
    isClusteringByDefaultTriggered: null, // TODO: Update to false once all accounts have LiveMap_ClusteringByDefault enabled
    hasClusteringBeenManuallyUpdated: false
  },
  vehiclesSortType: EVehiclesSortType.Vehicle,
  vehicleDriverPanel: {
    activeTab: EVehicleDriverPanelTabs.VehicleStatus,
    isCollapsed: false
  },
  vehicleListPanel: {
    selectionMode: EVehicleSelectionMode.Vehicles
  }
};
